"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import CourseQuizFlow from "./CourseQuizFlow";
import { saveSectionQuizResult } from "../lib/courseQuizProgress";

/**
 * Centered overlay (narrow on desktop) with native quiz flow — no iframe.
 */
export default function CourseQuizModal({
    open,
    onClose,
    quizId,
    sectionTitle = "الاختبار",
    courseId,
    sectionKey,
    gated = false,
    sectionThreshold,
    onQuizPassed,
}) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, [open]);

    if (!mounted || !open || !quizId) return null;

    const handleComplete = (data) => {
        // Gated sections are tracked server-side (course_progress); don't shadow with localStorage.
        if (!gated && courseId != null && sectionKey && quizId != null) {
            saveSectionQuizResult(String(courseId), sectionKey, {
                passed: data.passed,
                quizId: Number(quizId),
            });
        }
        onQuizPassed?.(data);
    };

    const modal = (
        <div
            className="position-fixed top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center px-2 py-3 px-md-4"
            style={{ zIndex: 1080, background: "rgba(0,0,0,0.55)" }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="course-quiz-modal-title"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-4 shadow-lg w-100 d-flex flex-column overflow-hidden"
                style={{
                    maxWidth: "min(520px, 100%)",
                    maxHeight: "min(88vh, 760px)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="border-bottom d-flex align-items-center justify-content-between gap-2 px-3 py-2 flex-shrink-0 bg-light"
                    style={{ minHeight: 48 }}
                >
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="إغلاق الاختبار"
                        onClick={onClose}
                    />
                    <h2
                        id="course-quiz-modal-title"
                        className="fs-6 fw-bold mb-0 text-center text-truncate flex-grow-1 px-1"
                        dir="rtl"
                    >
                        {sectionTitle}
                    </h2>
                    <span style={{ width: 32 }} aria-hidden />
                </div>
                <div className="flex-grow-1 overflow-hidden d-flex flex-column" style={{ minHeight: 0 }}>
                    <CourseQuizFlow
                        quizId={quizId}
                        mode={gated ? "section" : "quiz"}
                        courseId={courseId}
                        sectionKey={sectionKey}
                        sectionThreshold={sectionThreshold}
                        onClose={onClose}
                        onComplete={handleComplete}
                    />
                </div>
            </div>
        </div>
    );

    return createPortal(modal, document.body);
}
